var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"export"},[_c('button',{on:{"click":function($event){return _vm.exportXLSX(_vm.question_result)}}},[_c('DownloadFile'),(_vm.xlsxLoader)?_c('span',[_c('Loader',{attrs:{"color":"#696969"}})],1):_vm._e()],1),_c('div',{staticClass:"text-hover"},[_vm._v("\n    "+_vm._s(_vm.parseTranslation(_vm.DOWNLOAD_TABLE))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }